import { Component, OnInit, Input, Optional, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'kt-legacy-education',
  templateUrl: './legacy-education.component.html',
  styleUrls: ['./legacy-education.component.css']
})
export class LegacyEducationComponent implements OnInit {
  @Input() eduId: number;
  @ViewChild('legacyDetails', { static: false }) legacyDetails: NgForm;

  constructor(private dialogRef: MatDialogRef<LegacyEducationComponent>,@Optional() @Inject(MAT_DIALOG_DATA) public data: any,) { }

  ngOnInit() {
    this.eduId = this.data.eduId;
  }

  public verifyAttestation(){
  }

}
